import './styles.css';

export default function Toggle({ 
    checked = false, 
    onChange, 
    disabled = false, 
    size = "medium",
    className = ""
}) {
    const handleToggle = () => {
        if (!disabled && onChange) {
            onChange(!checked);
        }
    };

    return (
        <div 
            className={`toggle-container ${size} ${disabled ? 'disabled' : ''} ${className}`}
            onClick={handleToggle}
            role="switch"
            aria-checked={checked}
            aria-disabled={disabled}
            tabIndex={disabled ? -1 : 0}
        >
            <div className={`toggle-track ${checked ? 'checked' : ''}`}>
                <div className={`toggle-thumb ${checked ? 'checked' : ''}`}></div>
            </div>
        </div>
    );
}
